import { Request } from '~src/httpClient/serverApi/requests/Request';
import {IResult} from '~src/httpClient/serverApi/types/IResponse';


export interface IRegisterSiteEncryptionKeyParams {
  keyMetadata: {
    externalKeyId: string;
    keyRegion: string;
    keyDescription: string;
  };
}

export interface RegisterSiteEncryptionKeyResult extends IResult {
  policy: string;
}

export class RegisterSiteEncryptionKeyRequest extends Request<IRegisterSiteEncryptionKeyParams, RegisterSiteEncryptionKeyResult> {
  constructor(params: IRegisterSiteEncryptionKeyParams) {
    super('registerSiteEncryptionKey', params);
  }
}